module.exports = __webpack_public_path__ + "img/oem5.6bdfc30c.png";